export default {
  swabs: [
    { key: 'name', header: 'Etablissement' },
    { key: 'finess', header: 'FINESS' },
    { key: 'swuf', header: 'UF' },
    { key: 'code', header: 'Service' },
    { key: 'beds', header: 'Lits' },
    { key: 'cli', header: 'Réanimateur' },
    { key: 'clie', header: 'Mail réanimateur' },
    { key: 'chk', header: 'Checklist' },
    { key: 'cvc', header: 'Protocole pose CVC' },
    { key: 'cvo', header: 'Protocole pose CVO' },
    { key: 'picc', header: 'Protocole pose PICClines' },
    { key: 'mid', header: 'Protocole pose MIDlines' },
    { key: 'chg', header: 'CHG 2% pose CVC' },
    { key: 'chga', header: 'Avec applicateur' },
    { key: 'pad', header: 'Pansements occlusifs/stériles/transparents' },
    { key: 'padr', header: 'Protocole réfection pansements' },
    { key: 'ctn', header: 'Protocole de branchement' },
    { key: 'obs', header: 'Observation des pratiques' },
    { key: 'less', header: 'Formation' },
    { key: 'ikt', header: 'Cathéters imprégnés < 12 mois' },
    { key: 'iktt', header: 'Type cathéter imprégné' },
    { key: 'iktf', header: 'Fréquence utilisation cathéter imprégné' },
    { key: 'ipd', header: 'Pansements imprégnés < 12 mois' },
    { key: 'ipdt', header: 'Type pansement imprégné' },
    { key: 'ipdf', header: 'Fréquence utilisation pansement imprégné' },
    { key: 'isp', header: 'Eponges imprégnés < 12 mois' },
    { key: 'ispt', header: 'Type éponge imprégnée' },
    { key: 'ispf', header: 'Fréquence utilisation épongé imprégnée' },
    { key: 'ict', header: 'Utilisation connectique < 12 mois' },
    { key: 'ictt', header: 'Type de connectique' },
    { key: 'ictf', header: 'Fréquence utilisation connectique' },
    { key: 'edl', header: 'Utilisation dispositif EDELVAISS-MULTILINE' },
    { key: 'edlt', header: 'Type de dispositif EDELAVISS-MULTILINE' },
    { key: 'edlf', header: 'Fréquence utilisation dispositif' },
    { key: 'edld', header: 'Durée moyenne du maintien en jours' },
    { key: 'ist', header: 'Utilisation stabilisateur < 12 mois' },
    { key: 'istt', header: 'Type de stabilisateur' },
    { key: 'istf', header: 'Fréquence utilisation stabilisateur' },
    { key: 'ilo', header: 'Utilisation verrous < 12 mois' },
    { key: 'ilot', header: 'Type de verrou' },
    { key: 'ilof', header: 'Fréquence utilisation verrou' },
    { key: 'iwa', header: 'Toilette avec CHG' },
    { key: 'iwat', header: 'Toilettes CHG/patient sur 1 semaine' },
    { key: 'iwaf', header: 'Fréquence toilette' },
    { key: 'ioi', header: 'Pommade antibiotique' },
    { key: 'ioit', header: 'Type pommade antibio' },
    { key: 'ioif', header: 'Fréquence pommade antibio' },
    { key: 'status', header: 'Statut' },
    { key: 'creno', header: 'CRENO' },
    { key: 'label', header: 'Label' },
    { key: 'wepdt', header: 'Date épisode' },
    { key: 'wsex', header: 'Sexe patient' },
    { key: 'wiwa', header: 'Patient : Toilette chlorexidine < 7j' },
    { key: 'wiwat', header: 'Patient : Nb toilettes CHG/semaine' },
    { key: 'wifkt', header: "Patient : Port d'un cathéter central ou assimilé" },
    { key: 'wchg', header: 'Patient : CHG 2% pose CVC' },
    { key: 'wpad', header: 'Patient : Pansement stérile' },
    { key: 'wpadr', header: 'Patient : Nb réfections pansement' },
    { key: 'wikt', header: 'Patient : Cathéter imprégné' },
    { key: 'wiktt', header: 'Patient : Type cathéter imprégné' },
    { key: 'wipd', header: 'Patient : Pansements imprégnés' },
    { key: 'wipdt', header: 'Patient : Type pansements imprégnés' },
    { key: 'wisp', header: 'Patient : Eponges imprégnés' },
    { key: 'wispt', header: 'Patient : Type eponges imprégnés' },
    { key: 'wict', header: 'Patient : Connectiques imprégnés' },
    { key: 'wictt', header: 'Patient : Type connectiques' },
    { key: 'wedl', header: 'Patient : Utilisation dispositif EDELVAISS-MULTILINE' },
    { key: 'wedlt', header: 'Patient : Type de dispositif EDELAVISS-MULTILINE' },
    { key: 'wedlm', header: `Patient : Dispositif en place depuis` },
    { key: 'wist', header: 'Patient : Stabilisateur cathéter' },
    { key: 'wistt', header: 'Patient : Type stabilisateur' },
    { key: 'wilo', header: 'Patient : Verrous' },
    { key: 'wilot', header: 'Patient : Type verrous' },
    { key: 'wioi', header: 'Patient : Pommade antibiotique' },
    { key: 'wioit', header: 'Patient : Type pommade antibio' }
  ]
}
